import { render, staticRenderFns } from "./swiperComponent.vue?vue&type=template&id=00c60abe&scoped=true"
import script from "./swiperComponent.vue?vue&type=script&lang=js"
export * from "./swiperComponent.vue?vue&type=script&lang=js"
import style0 from "./swiperComponent.vue?vue&type=style&index=0&id=00c60abe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c60abe",
  null
  
)

export default component.exports